import { message, Modal, Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import SearchImage from "../../../assets/Seggreagtion/search.jpg";
import "./style.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useGetDraftSkuForSegregation,
  useLogoutUser,
} from "../../../hooks/useSeggregation";
import { SeggreagtionContext } from "../../../context/seggregationProvider";
import Button from "../../../common/Button";

const BatchLoading = () => {
  const [payload, setPayload] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [draftSkuId, setDraftSkuId] = useState();
  const [marketPlaceId, setMarketPlaceId] = useState();
  const {
    segg_setSelectedCategory,
    segg_setSelectedSubCategory,
    segg_setSelectedMarketplace,
    segg_setSelectedVariant,
    seggg_setQueryParams,
    segg_queryParams,
    segg_setLogoutPayload,
  } = useContext(SeggreagtionContext);
  useEffect(() => {
    segg_setSelectedMarketplace("");
    segg_setSelectedVariant("");
    const queryParams = new URLSearchParams(location.search);
    seggg_setQueryParams(location.search);
    const batchId = queryParams.get("batchId");
    const orgId = queryParams.get("orgId");
    if (batchId) {
      setPayload({ batchId });
      getDraftSku({ batchId });
    } else if (orgId) {
      setPayload({ organizationId: orgId });
      getDraftSku({ organizationId: orgId });
    }
  }, [location]);

  const onSuccess = (res) => {
    if (res.status === 200) {
      if (res.data.data === null) {
        message.warning("No Sku Found");
        segg_setSelectedCategory("");
        segg_setSelectedSubCategory("");
        setTimeout(() => {
          if (segg_queryParams.includes("org")) {
            navigate(`/seggregation-batch-list?activeProfile=client`);
          } else {
            navigate(`/seggregation-batch-list?activeProfile=batch`);
          }
        }, 2000);
      } else {
        setDraftSkuId(res?.data?.data?._id);
        setMarketPlaceId(res?.data?.data?.toProcessFilesDraft[0]?.marketplace);
        if (res?.data?.data?.toProcessFilesDraft.length > 1) {
          setIsBtnDisabled(true);
        }
        if (
          res?.data?.data?.toProcessFilesDraft.length === 1 &&
          localStorage.getItem("seggregationVersion") &&
          localStorage.getItem("seggregationVersion") === "version2"
        ) {
          // handleBtnClick("version2");
          navigate(
            `/bst-seggregation/${res?.data?.data?._id}/${res?.data?.data?.toProcessFilesDraft[0]?.marketplace}`
          );
        } else {
          setShowModal(true);
        }
        segg_setLogoutPayload({
          draftSkuId: res?.data?.data?._id,
        });
      }
    }
  };

  const onError = (err) => {
    console.log(err);
  };
  const { mutate: getDraftSku } = useGetDraftSkuForSegregation(
    onSuccess,
    onError
  );
  const { mutate: logoutUser } = useLogoutUser();
  const handleCancel = () => {
    setShowModal(false);
    logoutUser({
      draftSkuId: draftSkuId,
    });
    if (segg_queryParams.includes("org")) {
      navigate(`/seggregation-batch-list?activeProfile=client`);
    } else {
      navigate(`/seggregation-batch-list?activeProfile=batch`);
    }
  };
  const handleBtnClick = (version) => {
    localStorage.setItem("seggregationVersion", version);
    if (version === "version1") {
      navigate(`/select-category/${draftSkuId}`);
    } else if (version === "version2") {
      navigate(`/bst-seggregation/${draftSkuId}/${marketPlaceId}`);
    }
  };
  const getModal = () => {
    return (
      <Modal
        title="Seggregation"
        open={showModal}
        onCancel={handleCancel}
        className="seggregation_modal_wrapper"
        centered
        footer={null}
        width={"45%"}
        height={"40dvh"}
        // closable={false}
        maskClosable={false}
      >
        <div className="seggregation_modal_container">
          <div className="seggregation_text">
            You have two options for segregation. Please choose one:
          </div>
          <div className="action_wrapper">
            <button
              className="resumeOrder"
              onClick={() => handleBtnClick("version1")}
            >
              Version 1
            </button>
            <Button
              width="210px"
              height="50px"
              text="Version 2"
              handleClick={() => handleBtnClick("version2")}
              isDisabled={isBtnDisabled}
            />
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <div className="batch_loading_container">
      <div className="batch_loading_content">
        <div className="image_wrapper">
          <img src={SearchImage} alt="searchImage" />
        </div>
        <div className="heading">Fetching Order</div>
        <div className="sub_heading">
          Please wait while we fetch orders for you
        </div>
        <div className="loading_icon_wrapper">
          <Spin size="large" />
        </div>
      </div>
      {showModal && getModal()}
    </div>
  );
};

export default BatchLoading;
